import * as React from "react";

import { formatPolicyActionLabel } from "./policyTreeUtils";

function policyActionKind(actionLabel: string): "remove" | "keep" | "other" {
  if (actionLabel === "Remove") return "remove";
  if (actionLabel === "Keep Only" || actionLabel === "Keep") return "keep";
  return "other";
}

/** User-facing Remove / Keep Only label for policy action fields. */
export function formatPolicyActionDisplayLabel(action: unknown): string | null {
  const label = formatPolicyActionLabel(action);
  if (label === "Keep") return "Keep Only";
  return label;
}

export function PolicyActionField({ actionLabel }: { actionLabel: string }): React.ReactElement {
  const actionKind = policyActionKind(actionLabel);

  return (
    <p
      className="m-0 font-[family-name:var(--font-primary)] text-sm leading-tight"
      data-policy-action-field=""
      data-policy-action={actionKind}
    >
      <span
        className="font-medium text-[color:var(--brand-tropical-surf)]"
        data-policy-action-label=""
      >
        Action:
      </span>{" "}
      <span
        className="font-normal text-gray-500 dark:text-white"
        data-policy-action-value=""
      >
        {actionLabel}
      </span>
    </p>
  );
}
